import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { App as CapacitorApp } from '@capacitor/app';

/**
 * Gere le bouton retour materiel d'Android.
 *
 * Par defaut, Capacitor ferme l'application au moindre appui sur « retour ».
 * On remplace ce comportement : tant qu'une page precedente existe et qu'on
 * n'est pas sur un ecran racine, on revient en arriere dans l'app ; sur un
 * ecran racine (accueil, tableau de bord, connexion), l'appui ferme l'app.
 *
 * N'a aucun effet sur le web (Capacitor.isNativePlatform() renvoie false).
 */
const ROUTES_RACINE = ['/', '/login', '/coach/dashboard', '/sportif/dashboard'];

const AndroidBackButton = () => {
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    let handle: { remove: () => void } | undefined;
    CapacitorApp.addListener('backButton', ({ canGoBack }) => {
      const surRacine = ROUTES_RACINE.includes(window.location.pathname);
      if (canGoBack && !surRacine) {
        window.history.back();
      } else {
        CapacitorApp.exitApp();
      }
    }).then((h) => { handle = h; });

    return () => { handle?.remove(); };
  }, []);

  return null;
};

export default AndroidBackButton;
